import { Button, Col, Container, Form, InputGroup, Row, } from "@themesberg/react-bootstrap";
import React, { useEffect, useState } from "react";
import { activateGeod, closeGeod } from "../../Store";
import { faEye, faUnlockAlt } from "@fortawesome/free-solid-svg-icons";

import BgImage from "../../assets/img/illustrations/signwithmobile.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { connect } from "react-redux";
import { postOtpVerification } from "../../Service/AllLoginAPI";
import swal from "sweetalert";
import { useHistory } from "react-router-dom";

const SignOtp = (props) => {
  const history = useHistory();
  const [otp, setOtp] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const passwordInputType = showPassword ? "text" : "password";
  const passwordIconColor = showPassword ? "#262B40" : "";

  const geodTitle = props.geod?.title;
  useEffect(() => {
    const token = sessionStorage.getItem("token");
    const loginStatus = sessionStorage.getItem("loginStatus");
    const hasToken = !!token && token !== "null" && token !== "undefined" && token !== "";
    const isLoggedStatus = loginStatus === "true" || loginStatus === true;
    if (hasToken || isLoggedStatus || geodTitle) {
      history.replace("/");
    }
  }, [history, geodTitle]);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const submitOtp = async (e) => {
    try {
      e.preventDefault();
      if (otp !== "") {
        const data = {
          otp: otp,
        };
        console.log("postOtpVerification data :-", data);
        await postOtpVerification(data)
        .then((result) => {
          console.log("postOtpVerification result", result);
          sessionStorage.setItem("loginStatus", true);
          sessionStorage.setItem("token", result?.data?.token);
          sessionStorage.setItem("refreshToken", result?.data?.refreshToken);
          sessionStorage.setItem( "userName", result?.data?.perList[0]?.userName );
          sessionStorage.setItem("role", result?.data?.perList[0]?.role);
          sessionStorage.setItem( "pkUserId", result?.data?.perList[0]?.pkUserId );
          sessionStorage.setItem( "firstName", result?.data?.perList[0]?.firstName );
          sessionStorage.setItem( "lastName", result?.data?.perList[0]?.lastName );
          sessionStorage.setItem( "moduleName", result?.data?.perList[0]?.moduleName );
          try {
            localStorage.setItem("userName", result?.data?.perList[0]?.userName);
            localStorage.setItem("pkUserId", result?.data?.perList[0]?.pkUserId);
            localStorage.setItem("firstName", result?.data?.perList[0]?.firstName);
          } catch (e) {}
          props.activateGeod({ title: true });
          swal("Great", "Login successfully", "success").then(() => {
            history.replace("/");
          });
        })
        .catch((error) => {
          console.log("Login Error", error);
          swal("Login Failed", "Check OTP", "error");
        });
      } else {
        swal("Failed", "Please enter OTP", "error");
      }
    } catch (error) {
      console.log(error);
      swal( "Failed", "Something went wrong please check your internet", "error" );
    }
  };

  return (
    <main>
      <section className="vh-lg-100 bg-soft d-flex align-items-center my-4">
        <Container>
          <Row
            className="justify-content-center form-bg-image"
            style={{ backgroundImage: `url(${BgImage})` }}
          >
            <Col
              xs={12}
              className="d-flex align-items-center justify-content-center"
            >
              <div className="bg-white shadow-soft border border-light rounded p-4 p-lg-5 w-100 fmxw-500">
                <div className="text-center text-md-center mb-4 mt-md-0">
                  <h3 className="signinHead mb-0">Sign In With Mobile</h3>
                </div>
                <Form className="mt-5">
                  <Form.Group id="password" className="mb-4">
                    <Form.Label>Your OTP</Form.Label>
                    <InputGroup>
                      <InputGroup.Text>
                        <FontAwesomeIcon icon={faUnlockAlt} />
                      </InputGroup.Text>
                      <Form.Control
                        required
                        type={passwordInputType}
                        placeholder="Enter Your OTP"
                        onChange={(e) => setOtp(e.target.value)}
                      />
                      <InputGroup.Text
                        style={{
                          borderRight: "0.0625rem solid #d1d7e0",
                        }}
                        onClick={togglePasswordVisibility}
                      >
                        <FontAwesomeIcon
                          color={passwordIconColor}
                          icon={faEye}
                        />
                      </InputGroup.Text>
                    </InputGroup>
                  </Form.Group>
                  <Button
                    variant="primary"
                    type="submit"
                    className="w-100"
                    onClick={submitOtp}
                  >
                    Send In
                  </Button>
                </Form>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </main>
  );
};

const mapStateToProps = (state) => {
  return {
    geod: state.geod,
  };
};

const mapDispatchToProps = {
  activateGeod,
  closeGeod,
};

const AppContainer = connect(mapStateToProps, mapDispatchToProps)(SignOtp);
export default AppContainer;
